// import { GetStaticProps } from 'next';

import { GetServerSideProps } from 'next';

// TODO: maybe bring back in the future
// import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
// import { SWRConfig } from 'swr';

// import CpdCourseOic from '@components/organisms/cpd/courses/oic';
// import cpdAPI, { CPD_END_POINT } from 'src/api/cpd';
// import Seo from 'src/components/atoms/seo';
// import Main from 'src/components/templates/main';
// import config from 'src/config';
// import { CPDLicenseTypeEnum, CPDRegulatorTypeEnum, FilterLicenseTypeEnums } from 'src/interfaces';

// const CpdOicNonLife = ({ fallback }: any) => (
//   <SWRConfig value={{ fallback }}>
//     <Main scrollToTop isFooterCpd>
//       <Seo
//         title="หลักสูตรอบรมเก็บชั่วโมงออนไลน์สำหรับนายหน้าตัวแทนประกันวินาศภัย"
//         description="SkillLaneCPD | หลักสูตรอบรมเก็บชั่วโมงออนไลน์ เพื่อขอรับ/ขอต่ออายุใบอนุญาตนายหน้า ตัวแทนประกันวินาศภัย รับรองหลักสูตรโดย OIC (คปภ.)"
//         image_url={`${config.IMAGE_CDN_HOST}/assets/cpd-landing/seo-thumbnail-cpd.jpg`}
//       />
//       <CpdCourseOic licenseType={FilterLicenseTypeEnums.NON_LIFE} />
//     </Main>
//   </SWRConfig>
// );

// type Params = {
//   locale: string;
// };

// export const getStaticProps: GetStaticProps = async (context) => {
//   const { locale } = context as Params;
//   const response = await cpdAPI.fetchCPDCourses({
//     regulatorType: CPDRegulatorTypeEnum.OIC,
//     licenseType: CPDLicenseTypeEnum.NON_LIFE,
//   });
//   return {
//     props: {
//       fallback: {
//         [CPD_END_POINT.COURSES]: response.data || [],
//       },
//       ...(await serverSideTranslations(locale, ['common'])),
//     },
//     revalidate: config.REVALIDATE_SHORT,
//   };
// };

// export default CpdOicNonLife;

export const getServerSideProps: GetServerSideProps = async () => {
  return {
    redirect: {
      destination: '/cpd',
      permanent: false,
    },
  };
};

const CpdOicNonLife = () => {};

export default CpdOicNonLife;
